import { render, staticRenderFns } from "./appForm.vue?vue&type=template&id=672a4d19&scoped=true&"
import script from "./appForm.vue?vue&type=script&lang=js&"
export * from "./appForm.vue?vue&type=script&lang=js&"
import style0 from "./appForm.vue?vue&type=style&index=0&id=672a4d19&prod&scoped=true&lang=css&"
import style1 from "./appForm.vue?vue&type=style&index=1&id=672a4d19&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672a4d19",
  null
  
)

export default component.exports